import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TaskCardItem } from "./task-card.item";

@Component({
    selector: "kno2-task-card",
    templateUrl: "./task-card.component.html",
    styleUrls: ["./task-card.component.scss"],
    standalone: false
})
export class TaskCardComponent {
    @Input()
    public task: TaskCardItem;

    @Output()
    public actionEvent: EventEmitter<string> = new EventEmitter<string>();

    constructor() {}

    public performAction(): void {
        this.actionEvent.emit(this.task.type);
    }
}
